// Opt-in to Webpack hot module replacement.
if (module.hot) module.hot.accept();

import('./bootstrap');

export {};
